import { Stack, Typography } from '@ace-clublabs/shared-component-library';
import { RoleType } from '@ace-clublabs/common-membership-api-types';
import { stringHelper } from '../../utils/stringHelper';
import { getTermPeriodText } from '../../utils/ruleHelper';
import { useGlobalState } from '../../state/state';

export interface IRoleTypeRadioLabelProps {
  checked: boolean;
  roleType: RoleType;
  limitPerHousehold: number;
  inRenewal: boolean;
  cost: number;
  minAge?: number;
  maxAge?: number;
  disabled?: boolean;
}

export const RoleTypeRadioLabel = ({
  checked,
  roleType,
  limitPerHousehold,
  minAge,
  maxAge,
  cost,
  inRenewal,
  disabled,
}: IRoleTypeRadioLabelProps) => {
  const [formData] = useGlobalState('formData');
  const ageLimitMessage = getAgeRangeMessage(minAge!, maxAge!);

  const roleTypeLabel =
    roleType === RoleType.ADULT_ASSOCIATE ? 'Adult' : roleType === RoleType.DEPENDENT ? 'Dependent' : 'Associate';

  return (
    <Stack direction={'column'} alignItems="start" gap="0.5rem" sx={{ width: '100%' }}>
      <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{ width: '100%' }}>
        <Typography
          className="role-type-label"
          variant="b1Regular"
          sx={{ fontWeight: checked && !disabled ? '500' : '400', color: disabled ? '#707070' : '' }}
        >
          {roleTypeLabel}
        </Typography>
        {disabled ? (
          <></>
        ) : (
          <Stack className="cost-label" direction="row" alignItems="baseline">
            <Typography variant="b2Regular" className="price-label" sx={{ fontWeight: disabled ? '400' : '500' }}>
              {stringHelper.formatMoney(cost?.toString())}
            </Typography>
            <Typography className="pay-term-label" variant="b3Regular">
              /{getTermPeriodText(inRenewal, formData?.requestedBillPlan!)}
            </Typography>
          </Stack>
        )}
      </Stack>
      <Stack direction={'column'} justifyContent="flex-start">
        <Typography className="limit-per-household-label" variant="b3Regular" sx={{ lineHeight: '1.375rem' }}>
          Limit of {limitPerHousehold} per household
        </Typography>
        <Typography
          className="age-range-label"
          variant="b3Regular"
          sx={{ alignSelf: 'baseline', lineHeight: '1.375rem' }}
        >
          {ageLimitMessage}
        </Typography>
      </Stack>
    </Stack>
  );
};

const getAgeRangeMessage = (minAge: number, maxAge: number) => {
  if (minAge > 0 && maxAge < 140) {
    return `Must be ${minAge}-${maxAge} years old`;
  } else if (minAge > 0) {
    return `Must be ${minAge} or older`;
  } else if (maxAge < 140) {
    return `Must be ${maxAge} or younger`;
  }

  return '';
};
